import {closePopups, openModal} from "../modal/modal";

const goal_list = {
    //Запись на сервис
    'default' : 'vw_recall',
    'modal-service' : 'vw_service_order',
}

$(function () {
    const regex = '\\+7 \\([0-6,9]{1}[0-9]{2}\\) [0-9]{3}-[0-9]{2}-[0-9]{2}';
    const delEverythingExceptNumb = str => str.replace(/[^0-9]/g, '');
    $(".js-from-phone")
        .inputmask({ regex })
        .on("keyup", removeDisabledBtn)

    $(".js-form").on("submit", (e)=> {
        e.preventDefault();
        const target = $(e.currentTarget);
        const submitButton = target.find('button[type="submit"]')
        const actionUrl = target.attr("action");
        submitButton.attr("disabled", true);

        $.post(actionUrl, target.serialize())
            .done(()=> {
                const data = formData(target.serialize())
                console.log(data);

                closePopups();
                openModal("#modal-success")

                if (window.Comagic) {
                    comagicSend(data);
                }
                reachGoalYM(goal_list[data['form_key']] ?? goal_list['default']);
                reachGoalGA(goal_list[data['form_key']] ?? goal_list['default']);
            })
            .fail(()=> {
                closePopups();
                openModal("#modal-fail");
            })
            .always(()=> {
                target[0].reset()
                submitButton.attr("disabled", false);
            })
    })

    function removeDisabledBtn(e) {
        const target = $(e.currentTarget);
        const phone = delEverythingExceptNumb(e.target.value);
        const submitBtn = target.closest(".js-form").find('button[type="submit"]');
        phone.length >= 11 ? submitBtn.removeAttr("disabled") : submitBtn.attr("disabled", true)
    }

    function comagicSend(data) {

        var getdata = {},
            fields = ["name", "phone", "email"],
            message = ['subject', 'auto', 'date', 'link', 'model', 'text', 'comment', 'dealer'];

        fields.forEach(function (item) {
            if (data[item] !== null && data[item] !== undefined && data[item] !== '') {
                getdata[item] = data[item];
            }
        });

        getdata['message'] = '';

        message.forEach(function (item) {
            if (data[item] !== null && data[item] !== undefined && data[item] !== '') {
                getdata['message'] = getdata['message'] + '\n' + data[item];
            }
        });
        console.log(getdata)
        Comagic.push(['addOfflineRequest', getdata]);
    }

    /**
     * Отправка цели в Яндекс.Метрику
     * @param {string} goal имя цели
     * @param {object} added дополнительные параметры
     */
    function reachGoalYM(goal)
    {
        if (window['yaCounter' + window.ym_counter_id]) {
            console.log('yaCounter - ' + goal);
            window['yaCounter' + window.ym_counter_id].reachGoal(goal, {});
        }
    }

    /**
     * Отправка цели в Google Analytics
     * @param {string} goal имя цели
     */
    function reachGoalGA(goal)
    {
        if (window.ga) {
            console.log('ga - ' + goal);
            ga('send', 'event', goal);
        }
    }

    function formData($data) {
// Разбиваем сериализованные данные на массив пар ключ-значение
        var dataArray = $data.split('&');

// Создаем объект JavaScript для хранения данных формы
        var formData = {};

// Проходимся по каждой паре ключ-значение и добавляем их в объект formData
        dataArray.forEach(function(pair) {
            var keyValue = pair.split('=');
            var key = decodeURIComponent(keyValue[0]);
            var value = decodeURIComponent(keyValue[1] || '');
            if (formData[key] === undefined) {
                formData[key] = value;
            } else {
                if (!Array.isArray(formData[key])) {
                    formData[key] = [formData[key]];
                }
                formData[key].push(value);
            }
        });

// Теперь переменная formData содержит объект JavaScript с данными формы
        return formData;
    }

})
